'use strict';

var Params = function Params(padding, chartWidth) {
  return function (containerWidth, containerHeight) {
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: chartWidth,
      height: height,
      containerWidth: chartWidth,
      containerHeight: containerHeight,
      padding: padding,
      xAxisShift: 0,
      xAxisLabelShift: -50,
      xAxisTickSize: 0,
      yAxisShift: 10,
      yAxisTickSize: 0,
      yNumberOfTicks: 5,
      yAxisLabelShift: 65,
      forceWidth: true
    };
  };
};
module.exports = Params;